const ANONYMOUS_AVATAR_URL = 'http://turbo.popularpays.com/anonymous_user.jpg';

export function isAnonymousAvatarUrl(url: string | undefined): boolean {
  return url === ANONYMOUS_AVATAR_URL;
}

export function hasProfilePicture(url: string | undefined): boolean {
  return url !== undefined && !isAnonymousAvatarUrl(url);
}
